import PoiCategory from '../api/v3/models/IPoiCategory';
import PoiCategoryGroup from '../api/custom/IPoiCategoryGroup';
import POI_CATEGORY_GROUP from '../api/v3/enums/POI_CATEGORY_GROUP';
import HourFormat from '../api/v3/models/IHourFormat';
import plural from './plural';

const allCategoriesStatic: PoiCategory[] = [
  { id: 36, name: 'Desserts', description: null, parent: { id: 24, name: 'Cafes' } },
  { id: 33, name: 'Bakeries', description: null, parent: { id: 24, name: 'Cafes' } },
  { id: 1, name: 'Attractions', description: null, parent: { id: null, name: null } },
  { id: 31, name: 'Bars', description: null, parent: { id: 4, name: 'Nightlife' } },
  { id: 28, name: 'Stadium', description: null, parent: { id: 1, name: 'Attraction' } },
  { id: 30, name: 'Museums', description: null, parent: { id: 1, name: 'Attraction' } },
  { id: 35, name: 'Breweries', description: null, parent: { id: 4, name: 'Nightlife' } },
  { id: 24, name: 'Cafes', description: null, parent: { id: null, name: null } },
  { id: 4, name: 'Nightlife', description: null, parent: { id: null, name: null } },
  { id: 32, name: 'Art Galleries', description: null, parent: { id: 1, name: 'Attraction' } },
  { id: 26, name: 'Theater', description: null, parent: { id: 1, name: 'Attraction' } },
  { id: 3, name: 'Restaurants', description: null, parent: { id: null, name: null } },
  { id: 29, name: 'Civic Center', description: null, parent: { id: 1, name: 'Attraction' } },
  { id: 25, name: 'Religious Places', description: null, parent: { id: 1, name: 'Attraction' } },
];

const imgUrl = (apiPlaceUrl: string, x: number = 64, y?: number, type = 'Place'): string => {
  if (!apiPlaceUrl) {
    return 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxANDw8NDQ8PEA0NDQ0NDRAPDQ8QEBUOFREWFhUSFRYYHSggGBolGxUVITEhJSkrLjAuFx8zODYtNygvLisBCgoKBQUFDgUFDisZExkrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrK//AABEIAOEA4QMBIgACEQEDEQH/xAAbAAEAAgMBAQAAAAAAAAAAAAAAAQUDBAYCB//EAEMQAAICAQICBQgGCQMDBQAAAAABAgMEBRESIQYTMUFRFCIyYXGBkbEVQnKhwfAkM0NSYoKS0eEHIzRzdPEWJTVj0v/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD7iAAIBIAgEgAAAAAAAAAAAAAAAAAAAAAAAAACABIIAEggASAAAAAAAAAAAAAAAADXtzaoenbXH1OcUzXlrWMv20fdu/kgLAFetbxn+2j71JfgZ6tQpn6Ntb9SnHf4AbII3JAAAAAAAAAgEkAAAAAAEgAAAAAAAAHi62NcXObUYx5tt7ID2aWfqlOP+sl53dFc5fDu95WWahfmNwxE4VJ7Suly+Hh8/Ybmn6JVT5zXWWdrnPnz8Uu4DUWo5eR/x6erg+yy3w8V+WelodlvPJybJeMYco/fy+4vQBVVdHsaP7Ny+1OT/wAGxHScdfsa/fBM3QBpvSsd/sK/6EjXt0DGl+z2+zKS/EtABRPo+6+eNkWVvuT5x+7b8Tz5Vm4/62uN8F2yr5S+5fgX4ArsDWab+UZcM/3J8pb+rxLEr9Q0inI5yjtP9+PKXv8AH3ld1+Rg8rt78fsU16cV6/8APxA6EGHEyoXRU65KUX9z8Gu5mYAAAAAAAEAAABIAAAAAAY7rY1xc5vaMU3JvwA8ZmXCiDsse0V8W/BeLKSjGs1CSuv3hjJ711J7cXrf9/gMWmWoW9famsattU1v63rf4/A6FLYDzVWoJRilGMVsklskj2AAAAAAAAAAAAAhxTWz5p8mmSAOfzdOniyeRh+j2209zXqX4d3d4FppuoQyYccOTXKUX2xfh/k3Cg1TDljT8sxl2fr612OPe/wA+0C/BgwsqN8I2QfmyXvT70/WZwAAAEEkAAABIIJAAAAc/qU3mXrEg9qq3x5El4r6v57/YWer5vk9MrPrbcMPtvs/v7jB0fwupqUpfrbf9yxvt59i/PiwLGqtQioxSUYpJJdyPYAAAAAAAAAAAAAAAAAAhrckAc7H9AyOHsxcl8vCE/wA/d7DojT1XCWRVKt9rW8H4TXZ+fWa3R7MdtXDP9ZS+rmn28ux/nwYFqAABAAAAASCCQAAAoNU/SMunH7YVLrbF3eOz+5fzF+ii6PLrbcnJf17OCH2Vz+XD8C9AAESkkt20ku1t7ICQRGSfNc14kQmpLdNNeKe4HoGDyyri6vra+s/c448Xw33M4AHlzSajut32Lfm/YRGyLbSabj2pNNr2+AHsHmdijtxNLd7Ldpc/AmUklu3sl2tgSCIyTW6aafY090Y78mFa3snCCffOSivvAyg8V2xmlKMlKL7HFpr4o8vJrXJzgmuTXHHtAyg8V2xl6Moy27dmmewBQSXk2en2V5cdn4dZ/wCdv6i/KXpVU+qjbH0qLIzT9T5fPh+AFySY6LFOMZrsnGMl7GtzIAIJIAAAAwGAJNfULOCm2f7tc5L2qL2Ngr9eltjXfY2+LSAxdGK+HFh/E5yf9TXySLU0tGW2NT/0oP4rc3QBzv8AqH/8Vnf9tL5o6IpOm2HZk6dmUUQc7raJRrgnFNy3XLdtL4sCq6HXywrHpF8m4qpZOmzl9fFaXFVv3yrb2+y0c/iZVkNHxMWibqnqGr5GE7IPaUK55Vzm4vue0Wvedd0i0aeRjUzo2hn4XBfiSfdbGK4q5fwyW8X7Sk0/ozkXaRVRZHybPozLc7HU3Gahd5ROcE3FvdOMtveBcvoLpnVdT5HUuW3Wpf7/ABfv9b6XF377njoBmW2Y1tF83bZg5mRhO2XOU41y82Un3vZpe4xrXdS4Or+iLPKdtuN5WP5Lxfv8W/Fw9+3DuWPRPRpYGN1dk1ZkW225OTYlspX2S3lt6lyS9gFZrC/980v/ALTUflA5/SrXi61lZXZTlalZpuR4Kboqsok/5uOP8yOq1PAunq2n5Ma26KMbOhbZvHaMpqHAmt93vs+xdxWS6O3X1a1VODrllZvlOFPePOcKanXYtny8+G3PbsAqf9RrXk5VUF+p027T5z8HlZGTCMV7q1J/zo6Pp1Y7o42mQfn6nkRqs27ViV+fe/6Vw/zFTboOXPTd50t6hl6ni5+XBSh5qWRB8O++zUK4pcn3ctzfs6OvUNQycjPqmsemFeNgJXSg5R9Ky3euSa3k9tn4AZehEvJnl6XPt0+9ujfteHbvOr27byj7it6J6Xj6nVZq2pQhkWX3ZHVq9KdVOPCbjGEIvlH0W2zc/wDTf0fn4mVp9U3VZ1mLnxd8ptVSSlC3eyW+0ZLsXj2GPBx8zSHdj14ks3T7LbbqOpsqjdUrHvKqULGlKO7ezT/wGfo3RplWXOWm5tO19e0sLHyaZ0uUXv1sYLdxlty5bI5TQ/ohT1D6Rxo23/S+pNSeFdd/t9c9lxRi1278vWdPpOl33Z9OdPCqwKMam+uFfFVK62ViS3kq/Nilt4s1tAuztPebW9Lybo3annZVc678RRddlrcXtKxPsW/vAveiUMDgsnplMaYOajbtj2UbzS3W6kk3yl2l8VejalfkOavwbsRQUXF22UTU9990urk9ttl2+JaADU1arjouj41Ta9qW6+Rtni5bxkvGMl9wGh0es48Wp+EXD+ltL7kWJTdE3vjJeFk18n+JcgAAAAABgMASV/SBb4t32U/hJMsDW1Kvjptiu2VU0vbwvYDxoz3x6f8ApQ+RuFX0as4sWv8Ah4o/CT/DYtAABT9LNVeFh33x52qPV48f3sib4a4/1NAXAOL6MK+EszR8zJunfGmu+jIdsna6ba+GTjLffzLFLb2oseg2o2X4fV5Mt8vCtsw8tybbdlb242327x2e/rA6PcHHdHdWlKvUdYyLJ+SO23ySDm+COLQnHjjHsTm038DU6H52XTk1Qz7LJ/S2I82iM5Nqq6M5Sljw37F1c4Pb+Fgd4Dl5ZVn09GjrJ9R9D9b1XG+r63ylx4+Hs4tuW5PQDKsux8mV1k7JR1LOri5zcmoRs2jFb9y8AOnBV9JtVWDiX5T5uut9XH962Xm1x98mkUPQu7Jxr7dNz7p3XOijOpssk5ScZRUboJvujYnsvCQHZA+f5M4XarqNWVqWRi1ULC6iEM/yeG8qE57JvZ89ny8Sy6FZVssjNpjk2ZmBS6Vi5NrjNuxxbsrViS6xLlzA64HL/wCm2XZfptNt9k7bHZkqU7JucmlfNLdvwSSNLphY5ajp+PPLvxce2nNlbKnJdG8oKLju+zt+YHag5XTdLx1dXKvVsy6cZcUapamrYz257OH1l6jqkAPFr2jJ+EX8j2auqWcFFsvCqe3t25AV/RJfo3tsm/ki5K3o5Xw4tX8SlL4ybX3bFkAAAAAAGAwBJDRIYFF0afVvIxn+ytbj9l8vwXxL0oMz9Hzq7eyGTHq5/a5L/wDP3l+AOM6T41mpahjYNdk6asOH0hddCEZbX8XDRFcScW1zls9+47MAcFrOmX6dfiapPLvy1TbHGyFZVSnHFufDKX+3FbpS4XzMXS+F+HlX+SQm/pzHhjJxi2q8yMo19Y9uxdVNv2wPoRGwHEdJtN3p0/QMbijXdwRunGO/Di0R4m2+zeUku3te5i6TdH8uimOdHOyMq3TrI5VVU6ceKai/9xLq4J84cS27zvCQOOx7Ou12q+Cl1VmgxlGTi0vOyXJJvx2fYVvQ/pHjYNeVTku2Fj1LOsSWLkTXBKx7PeMWj6FsSBwuu3fTWRg4mLZbDHjGepXXKlpqVcuCmO1kdt+Nt7NdyZj1/SsjAsxdVlmZGW8O+NdsZ00prFuahY11cU3tvF89+zfuO+AHzqzLwqNX1OefWpwtjgdRKWJO9PahcWzUXt2o3ui6VmpXX4FNlGmPEjCxSpnRVZl9Zup11yS7I8m0kduAPnPQHpPi4Wn1Y+TK2F0LMhyj5LkS5SunJc4xa7GjJ0pzcW3O0rKyIO3BljZspceLZYvOUeDir4W09/FH0IAcbpuraLG6vyaiuF8pqFUoaZbXJSn5vpdWuHt2337zsgABTdKbtqOBelbZGCX3/gviXJQZT8ozq6+2GNHrJ/a5P58P3gXONV1cIVr6kIx+C2MoAAAAAAAYDAEkEhgV2u4XX0yivTj59f2l3e9bonRM3yimMn6cfMs+0u/39pYHPZH6Dk9cv+PkPaxLsjPt3+b+IHQgiL3W65p81t4EgAAAAAAAAAAAAAAAAAABr5+UqK52y7IrkvGXcviV/RvFca5XWfrMiXWSffw93zb95rZT8vyFTH/j474rWuyUvD5r4nQJbckAAAAAAAAAYDAEkEhgDBl40boSrmt4yW3rXg16zOAKDS8uWLZ5HkPzf2Fj7HHuX57OwvzT1PT4ZMOCfJrnCS7YvxRWYOozxpLGzPZVb9Vr1v8AH4gX4IT3JAAAAAAAAAAAAAABS6zqEnLyTH53WcpNfUj38+57fAjU9Wk5eT4nn3Pk5LnGHjz8fkbWkaXHHi23xWz52Tfe/BeoDNpmBHGrVce3tlLxl4m2ABAAAAAAAADAAEkEgAAABgzMSF8HCyO8X2eKfin3MzgDneHIwPR3vxV3fXgvz7vYW2BqdWQt65Lfvi+Ul7jcKrO0Kq18cd6rO1Tr5c/FoC1BQJ52N2qOTWu9ent8/mZaukdW/DbGyqXepRbX3c/uAugalWp0T9G6v3zSfwZsRti+yUX7JID2Dw7IrtkvijBbqNMPSurX88d/gBtApr+kdEeUOOyXcoR/uYXk5uRyrrVEH9afpbe9fgBb5mbXQuK2aiu5d79i7ymlk5Gf5tKdOO+Tsl6Ul6v8fE2cTQK4vrLpSus73PnHf2d/vLdLbkgNXTtOrxo8Na5v0pP0n7f7G2AAAAEAAAAAAAAkAAAAAAAAAAAAAMdtMZ8pxjJeEop/MyACtt0PGn21RX2XKPyZry6M4/cpr2T/ALouiAKVdGcf/wCx+2f9kbFWg40f2Sf2pSl92+xZADHTjwr5QhGP2YpfIyAASCABIIAEggAAAAAAAAASAAAIJAAAAAAAAAAAACABIIAEggASCABIIAEkAAAAAAAAAASAABAAAAAAAAAAAAASAAAAAAAAAAAAAAACAAAAAAAAf//Z';
  }

  const xy = `${x}x${y || x}`;
  const cloudfrontUrl = `https://d1drj6u6cu0e3j.cloudfront.net/${xy}/smart`;
  const imageTypeAndUrl = apiPlaceUrl.substring(apiPlaceUrl.indexOf(`/${type}/`));
  return cloudfrontUrl + imageTypeAndUrl;
};

const cityImgUrl = (apiPlaceUrl: string, x: number = 64, y?: number): string => {
  const xy = `${x}x${y || x}`;
  const cloudfrontUrl = `https://d1drj6u6cu0e3j.cloudfront.net/${xy}/smart`;
  const placeUrl = apiPlaceUrl.substring(apiPlaceUrl.indexOf('/City/'));
  return cloudfrontUrl + placeUrl;
};

const imgUrlThumbnails = (imageUrl: string): string | undefined => {
  const smartIndex = imageUrl.indexOf('/smart/');

  if (smartIndex === -1) {
    return undefined;
  }

  const xy = imageUrl.substring(38, smartIndex).split('x');
  const ratio = +xy[0] / 64;
  const y = +xy[1] / ratio;
  const thumbsnailPx = `64x${y}`;

  // /smart/filters:blur(80)/
  return `https://d1drj6u6cu0e3j.cloudfront.net/${thumbsnailPx}/smart/${imageUrl.substring(smartIndex + 7)}`;
};

const getCategoryGroups = (poiCategories?: PoiCategory[]): PoiCategoryGroup[] => {
  const allCategories = poiCategories || allCategoriesStatic;
  const parentCategories = allCategories.filter((category) => category.parent?.id === null);

  const results: PoiCategoryGroup[] = parentCategories.map((parentCategory) => {
    const result = { ids: [parentCategory.id], group: POI_CATEGORY_GROUP.UNKNOWN };
    if (parentCategory.id === 1) {
      result.group = POI_CATEGORY_GROUP.ATTRACTION;
    } else if (parentCategory.id === 3) result.group = POI_CATEGORY_GROUP.RESTAURANT;
    else if (parentCategory.id === 24) result.group = POI_CATEGORY_GROUP.CAFE;
    else if (parentCategory.id === 4) result.group = POI_CATEGORY_GROUP.NIGHTLIFE;

    allCategories.filter((category) => category.parent?.id === parentCategory.id).forEach((childCategory) => result.ids.push(childCategory.id));

    return result;
  });

  return results;
};

const getCategoryGroup = (categoryId: number, poiCategories?: PoiCategory[]): POI_CATEGORY_GROUP => {
  const allCategories = poiCategories || allCategoriesStatic;
  const parentCategoryId = allCategories.find((category) => category.id === categoryId)?.parent?.id || categoryId;

  if (parentCategoryId === 1) return POI_CATEGORY_GROUP.ATTRACTION;
  if (parentCategoryId === 3) return POI_CATEGORY_GROUP.RESTAURANT;
  if (parentCategoryId === 24) return POI_CATEGORY_GROUP.CAFE;
  if (parentCategoryId === 4) return POI_CATEGORY_GROUP.NIGHTLIFE;

  return POI_CATEGORY_GROUP.UNKNOWN;
};

const getSubCategoryIds = (parentCategoryId: number, poiCategories?: PoiCategory[]): number[] => {
  const allCategories = poiCategories || allCategoriesStatic;
  const subCategories = allCategories.filter((category) => category.parent?.id === parentCategoryId);
  return subCategories.map((subCategory) => subCategory.id).concat(parentCategoryId);
};

const hoursFormat = (hour: string | null) => {
  const daysArray = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  if (hour && hour.search(',') > -1) {
    const raw = hour.split('|');
    // To do model e ekle
    const hours: HourFormat[] = [];
    raw.forEach((item: string) => {
      const h = item.split(': ');
      const days = h[0].split(',');
      const clock = h[1].split(',').map((a) => a.trim());
      days.forEach((d) => {
        const day = d.replace(/ /g, '');
        const i = hours.findIndex((o) => o.day === day);
        if (i === -1) {
          hours.push({ day, clock });
        } else {
          hours[i].clock = hours[i].clock.concat(clock);
        }
      });
    });

    if (hours.length < 7) {
      const closeDays = daysArray.filter((day) => {
        return hours.every((h) => !h.day.includes(day));
      });

      closeDays.forEach((d) => {
        const currentIndex = daysArray.findIndex((day) => day === d);
        hours.splice(currentIndex, 0, { day: d, clock: ['Closed', ''] });
      });
    }
    return hours;
  }

  const formattedDays: HourFormat[] = daysArray.map((day) => {
    return {
      clock: [hour || ''],
      day,
    };
  });
  return formattedDays;
};

const compareStringForSort = (a: string, b: string): number => {
  const nameA = a.toLowerCase();
  const nameB = b.toLowerCase();
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};

const emailFormatValid = (email: string): RegExpMatchArray | null => {
  return email.match(
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );
};

const passwordFormatValid = (password: string): RegExpMatchArray | null => {
  return password.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9!-@#$^_:,. ]{8,})$/);
};

const toEngChars = (str: string): string => {
  return str
    .replace('Ğ', 'G')
    .replace('Ü', 'U')
    .replace('Ş', 'S')
    .replace('İ', 'I')
    .replace('Ö', 'O')
    .replace('Ç', 'C')
    .replace('ğ', 'g')
    .replace('ü', 'u')
    .replace('ş', 's')
    .replace('ı', 'i')
    .replace('ö', 'o')
    .replace('ç', 'c')
    .replace('á', 'a')
    .replace('é', 'e')
    .replace('í', 'i')
    .replace('ó', 'o')
    .replace('ú', 'u')
    .replace('ý', 'y')
    .replace('Á', 'A')
    .replace('É', 'E')
    .replace('Í', 'I')
    .replace('Ó', 'O')
    .replace('Ú', 'U')
    .replace('Ý', 'Y')
    .replace('à', 'a')
    .replace('è', 'e')
    .replace('ì', 'i')
    .replace('ò', 'o')
    .replace('ù', 'u')
    .replace('À', 'A')
    .replace('È', 'E')
    .replace('Ì', 'I')
    .replace('Ò', 'O')
    .replace('Ù', 'U')
    .replace('â', 'a')
    .replace('ê', 'e')
    .replace('î', 'i')
    .replace('ô', 'o')
    .replace('û', 'u')
    .replace('Â', 'A')
    .replace('Ê', 'E')
    .replace('Î', 'I')
    .replace('Ô', 'O')
    .replace('Û', 'U')
    .replace('ã', 'a')
    .replace('ñ', 'n')
    .replace('õ', 'o')
    .replace('Ã', 'A')
    .replace('Ñ', 'N')
    .replace('Õ', 'O')
    .replace('ä', 'a')
    .replace('ë', 'e')
    .replace('ï', 'i')
    .replace('ÿ', 'Y')
    .replace('Ä', 'A')
    .replace('Ë', 'E')
    .replace('Ï', 'I')
    .replace('Ÿ', 'Y');
};

const unicodeToString = (str: string): string => {
  return str
    .replace(/u00c7/g, 'Ç')
    .replace(/u00e7/g, 'ç')
    .replace(/u011f/g, 'ğ')
    .replace(/u0130/g, 'İ')
    .replace(/u0131/g, 'ı')
    .replace(/u00d6/g, 'Ö')
    .replace(/u00f6/g, 'ö')
    .replace(/u015e/g, 'Ş')
    .replace(/u015f/g, 'ş')
    .replace(/u00dc/g, 'Ü')
    .replace(/u00fc/g, 'ü');
};

const hourRange = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
];
const minuteRange = ['00', '30'];
const timeRange: Array<string> = [];

hourRange.forEach((h) => {
  return minuteRange.forEach((m) => {
    return timeRange.push(`${h}:${m}`);
  });
});

const deepCopy = <T>(oldObject: T): T => {
  return JSON.parse(JSON.stringify(oldObject)) as T;
};

const getYourGuideImageArrayFormat = (imgUrls: Array<string>, formatId: string) => {
  return imgUrls.map((img) => img.replace('[format_id]', formatId));
};

const getYourGuideImageFormat = (str: string, formatId: string): string => {
  return str.replace('[format_id]', formatId);
};

const companionTitleOptions = [{ value: 'Family member' }, { value: 'Friend' }, { value: 'Work colleague' }];

// const initialCompanionState: Companion = { id: 0, age: 1, name: '', answers: [], title: 'Family member', trips: [] };

const delay = async (ms: number) => {
  await new Promise((resolve) => setTimeout(resolve, ms));
};

/**
 * Capitalize first letter of string param
 * @param {string} any string
 * @returns {string} first letter is uppercase
 */
const capitalizeFirstLetter = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1);

const removeDuplicateValuesById = <T extends { id: number }>(duplicateItems: T[]) => {
  const uniqueItems = duplicateItems.filter((item, itemIndex, allItems) => {
    const firstItemIndex = allItems.findIndex((i) => {
      if (item && i && item.id && i.id) return i.id === item.id;
      // eslint-disable-next-line no-console
      // console.log('vallahi null falan geldi!', item, i);
      return false;
    });
    const isUniqueItem = firstItemIndex === itemIndex;
    return isUniqueItem;
  });
  return uniqueItems;
};

const removeDuplicateValues = <T>(duplicateItems: T[], compareFn: (t1: T, t2: T) => boolean) => {
  const uniqueItems = duplicateItems.filter((item, itemIndex, allItems) => {
    const firstItemIndex = allItems.findIndex((i) => compareFn(i, item));
    const isUniqueItem = firstItemIndex === itemIndex;
    return isUniqueItem;
  });
  return uniqueItems;
};

export {
  imgUrl,
  cityImgUrl,
  imgUrlThumbnails,
  deepCopy,
  getCategoryGroup,
  getCategoryGroups,
  getSubCategoryIds,
  getYourGuideImageArrayFormat,
  getYourGuideImageFormat,
  hoursFormat,
  compareStringForSort,
  hourRange,
  minuteRange,
  emailFormatValid,
  passwordFormatValid,
  toEngChars,
  timeRange,
  unicodeToString,
  plural,
  companionTitleOptions,
  // initialCompanionState,
  delay,
  capitalizeFirstLetter,
  removeDuplicateValuesById,
  removeDuplicateValues,
};
